// extracted by mini-css-extract-plugin
export var border = "_1f-8";
export var brand = "_1f-t";
export var button = "_1f-l";
export var center = "_1f-a";
export var centered = "_1f-6";
export var closeButton = "_1f-c";
export var disabledWrapper = "_1f-m";
export var error = "_1f-p";
export var extraLarge = "_1f-4";
export var extraSmall = "_1f-1";
export var fill = "_1f-i";
export var footer = "_1f-h";
export var footerAction = "_1f-j";
export var footerButtons = "_1f-k";
export var header = "_1f-7";
export var headerWithClose = "_1f-d";
export var icon = "_1f-o";
export var info = "_1f-s";
export var inline = "_1f-9";
export var large = "_1f-3";
export var main = "_1f-e";
export var modal = "_1f-0";
export var nearFull = "_1f-5";
export var neutral = "_1f-u";
export var noPadding = "_1f-g";
export var none = "_1f-v";
export var scrollable = "_1f-f";
export var small = "_1f-2";
export var success = "_1f-r";
export var tight = "_1f-n";
export var titleIcon = "_1f-b";
export var warn = "_1f-q";